/* chat2305 掉宝活动 */
import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API, BASE_XHH} = extractAPIValues()
function handleArgs(v) {
	return {
		...v,
		_notip: true
	}
}

// 活动基本信息
export function getInfo (args) {
	let url = BASE_API + '/chatroom/v2/settings/acc/list'
	return axiosGetHandler(url, handleArgs(args))
}

// 上报任务，组队大厅浏览10s
export function reportStay (args) {
	let url = BASE_XHH + '/heychat/activity/chat2305/view_hall_10s/'
	return axiosGetHandler(url, handleArgs(args))
}

// 上报任务，频道语音时长
export function reportTaskChatTime (args, formdata) {
	let url = BASE_XHH + '/heychat/activity/chat2305/channel_chatting/'
	return axiosPostHandler(url, handleArgs(args), formdata)
}

// 上报任务，语音组队成功
export function reportTaskChatTeam (args, formdata) {
	let url = BASE_XHH + '/heychat/activity/chat2305/team_up_success/'
	return axiosPostHandler(url, handleArgs(args), formdata)
}


// 上报任务，添加steam好友
export function reportAddSteam (args) {
	let url = BASE_XHH + '/heychat/activity/chat2305/steam_add_friends/'
	return axiosGetHandler(url, handleArgs(args))
}

// 上报任务，回应邀请加入频道
export function reportInviteJoinRoom (args, formdata) {
	let url = BASE_XHH + '/heychat/activity/chat2305/resp_invite_channel/'
	return axiosPostHandler(url, handleArgs(args), formdata)
}

// 上报任务，回应添加好友
export function reportAddFriend (args, formdata) {
	let url = BASE_XHH + '/heychat/activity/chat2305/resp_add_friend/'
	return axiosPostHandler(url, handleArgs(args), formdata)
}


// 获取未开的宝箱数
export function getBoxCount (args) {
	let url = BASE_XHH + '/heychat/activity/chat2305/get_box_count/'
	return axiosGetHandler(url, handleArgs(args))
}

